import React from 'react';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import LanguageSelector from '../common/LanguageSelector';

interface AuthHeaderProps {
  title: string;
  subtitle: string;
}

const AuthHeader = ({ title, subtitle }: AuthHeaderProps) => {
  const { t } = useLanguage();
  
  return (
    <div className="text-center">
      <div className="flex items-center justify-center relative mb-6 sm:mb-8">
        <img src="/images/Preto-Horizontal.svg" alt="Aura Logo" className="h-16 w-auto" />
        <div className="absolute right-0 top-0">
          <LanguageSelector />
        </div>
      </div>
      <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-2">{title}</h2>
      <p className="mt-2 text-sm text-gray-600 max-w-sm mx-auto">{subtitle}</p>
    </div>
  );
};

export default AuthHeader;